var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlipCardsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 15C29.5 23.0081 23.0081 29.5 15 29.5C6.99187 29.5 0.5 23.0081 0.5 15C0.5 6.99187 6.99187 0.5 15 0.5C23.0081 0.5 29.5 6.99187 29.5 15Z",
    fill: "white",
    stroke: "#E2CCAB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2823 12.0575L12.8832 11.5718L12.4997 12.0701L10.3972 14.8022L9.7778 15.6071H10.7935H19.2035H20.1972L19.6051 14.8092L16.9018 11.1663L16.5071 10.6344L16.1037 11.1598L14.3845 13.3988L13.2823 12.0575ZM21.1771 7.21428V17.7143C21.1771 18.111 20.8553 18.4286 20.4756 18.4286H9.52138C9.14174 18.4286 8.81995 18.111 8.81995 17.7143V7.21428C8.81995 6.81754 9.14174 6.5 9.52138 6.5H20.4756C20.8553 6.5 21.1771 6.81754 21.1771 7.21428Z",
    stroke: "#E2CCAB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.59178 15.7188C5.27375 15.95 4.6377 16.7075 4.6377 17.8871C4.6377 19.6218 6.45912 21.8769 12.8775 22.6575",
    stroke: "#E2CCAB",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5867 15.7188C24.9336 16.0657 25.5408 16.7075 25.5408 17.8871C25.5408 19.6218 22.4183 22.5708 16.6071 22.831H15.5531",
    stroke: "#E2CCAB",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8723 22.8316L14.5393 22.4587C14.4331 22.5535 14.3723 22.6892 14.3723 22.8316C14.3723 22.9741 14.4331 23.1097 14.5393 23.2046L14.8723 22.8316ZM17.6339 21.0362C17.8399 20.8523 17.8578 20.5362 17.6739 20.3303C17.4899 20.1243 17.1739 20.1064 16.9679 20.2903L17.6339 21.0362ZM16.9679 25.373C17.1739 25.5569 17.4899 25.539 17.6739 25.333C17.8578 25.127 17.8399 24.8109 17.6339 24.627L16.9679 25.373ZM15.2053 23.2046L17.6339 21.0362L16.9679 20.2903L14.5393 22.4587L15.2053 23.2046ZM17.6339 24.627L15.2053 22.4587L14.5393 23.2046L16.9679 25.373L17.6339 24.627Z",
    fill: "#E2CCAB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlipCardsIcon);
export default __webpack_public_path__ + "static/media/flipCards_icon.fa0023e499e6ec9676c6ba73ca4e98be.svg";
export { ForwardRef as ReactComponent };